import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import MovieCategoryPage from "../pages/category/movie/page";
import TvCategoryPage from "../pages/category/tv/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import ActorPage from "../pages/actor/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/movie",
        element: <MovieCategoryPage />,
      },
      {
        path: "category/tv",
        element: <TvCategoryPage />,
      },
      {
        path: "detail/:id",
        element: <DetailPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "actor/:id",
        element: <ActorPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;